function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.5 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.153,16.032l-1.88-1.88L11.25,15.176l2.9,2.9,5.805-5.805L18.935,11.25Z",
  transform: "translate(-2.396 -3.195)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.208,22.568l-4.482-2.39A7.969,7.969,0,0,1,4.5,13.135V3.7A1.453,1.453,0,0,1,5.951,2.25H20.464A1.453,1.453,0,0,1,21.916,3.7v9.434a7.969,7.969,0,0,1-4.226,7.044ZM5.951,3.7v9.434A6.52,6.52,0,0,0,9.41,18.9l3.8,2.025,3.8-2.025a6.52,6.52,0,0,0,3.459-5.764V3.7Z",
  transform: "translate(0)",
  fill: "#d6d6d6"
}));

var SvgSecurity = function SvgSecurity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.416,
    height: 20.318,
    viewBox: "0 0 17.416 20.318",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security.809f4aaa.svg";
export { ForwardRef as ReactComponent };